import React from 'react';

export default function PlaceholderView({ title, description }) {
  return (
    <section className="panel placeholder-panel">
      <div className="panel-head compact">
        <div>
          <span className="panel-kicker">Planned next</span>
          <h2>{title}</h2>
        </div>
      </div>
      <p className="placeholder-copy">{description}</p>
    </section>
  );
}
